// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_Tuple = require("relude/src/Relude_Tuple.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function WithBimonad(Bimonad) {
  var make = function (mWriter) {
    return /* BiwriterT */{
            _0: mWriter
          };
  };
  var runWriterT = function (mWriter) {
    return mWriter._0;
  };
  var execWriterT = function (writerT) {
    return Curry._3(Bimonad.bimap, (function (prim) {
                  return prim[1];
                }), (function (prim) {
                  return prim[1];
                }), writerT._0);
  };
  var bimapWriterT = function (mAWBWToMCWBW, mAWBW) {
    return /* BiwriterT */{
            _0: Curry._1(mAWBWToMCWBW, mAWBW._0)
          };
  };
  var tell = function (w) {
    return /* BiwriterT */{
            _0: Curry._1(Bimonad.pure_left, [
                  undefined,
                  w
                ])
          };
  };
  var listen = function (mAWBW) {
    return /* BiwriterT */{
            _0: Curry._3(Bimonad.bimap, (function (param) {
                    var w = param[1];
                    return [
                            [
                              param[0],
                              w
                            ],
                            w
                          ];
                  }), (function (param) {
                    var w = param[1];
                    return [
                            [
                              param[0],
                              w
                            ],
                            w
                          ];
                  }), mAWBW._0)
          };
  };
  var pass = function (m) {
    return /* BiwriterT */{
            _0: Curry._3(Bimonad.bimap, (function (param) {
                    var match = param[0];
                    return [
                            match[0],
                            Curry._1(match[1], param[1])
                          ];
                  }), (function (param) {
                    var match = param[0];
                    return [
                            match[0],
                            Curry._1(match[1], param[1])
                          ];
                  }), m._0)
          };
  };
  var listens = function (w1ToW2, writerTMABW1) {
    var m = listen(writerTMABW1);
    return /* BiwriterT */{
            _0: Curry._3(Bimonad.bimap, (function (param) {
                    var match = param[0];
                    var w1 = match[1];
                    return [
                            [
                              match[0],
                              Curry._1(w1ToW2, w1)
                            ],
                            w1
                          ];
                  }), (function (param) {
                    var match = param[0];
                    var w1 = match[1];
                    return [
                            [
                              match[0],
                              Curry._1(w1ToW2, w1)
                            ],
                            w1
                          ];
                  }), m._0)
          };
  };
  var censor = function (wToW, mABW) {
    return pass(/* BiwriterT */{
                _0: Curry._3(Bimonad.bimap, (function (param) {
                        return [
                                [
                                  param[0],
                                  wToW
                                ],
                                param[1]
                              ];
                      }), (function (param) {
                        return [
                                [
                                  param[0],
                                  wToW
                                ],
                                param[1]
                              ];
                      }), mABW._0)
              });
  };
  var bimapWithAppendLog = function (appendLog, aToC, bToD, mABW) {
    return /* BiwriterT */{
            _0: Curry._3(Bimonad.bimap, (function (param) {
                    return [
                            Curry._1(aToC, param[0]),
                            Curry._1(appendLog, param[1])
                          ];
                  }), (function (param) {
                    return [
                            Curry._1(bToD, param[0]),
                            Curry._1(appendLog, param[1])
                          ];
                  }), mABW._0)
          };
  };
  var mapLeftWithAppendLog = function (appendLog, aToB, writerT) {
    return bimapWithAppendLog(appendLog, aToB, Relude_Globals.id, writerT);
  };
  var mapRightWithAppendLog = function (appendLog, bToC, writerT) {
    return bimapWithAppendLog(appendLog, Relude_Globals.id, bToC, writerT);
  };
  var bimap = function (aToC, bToD, writerT) {
    return bimapWithAppendLog(Relude_Globals.id, aToC, bToD, writerT);
  };
  var mapLeft = function (aToB, writerT) {
    return bimap(aToB, Relude_Globals.id, writerT);
  };
  var mapRight = function (bToC, writerT) {
    return bimap(Relude_Globals.id, bToC, writerT);
  };
  var applyLeftWithAppendLog = function (appendLog, mAToBCW, mACW) {
    return /* BiwriterT */{
            _0: Curry._2(Bimonad.apply_left, Curry._2(Bimonad.map_left, (function (param, param$1) {
                        return [
                                Curry._1(param[0], param$1[0]),
                                Curry._2(appendLog, param[1], param$1[1])
                              ];
                      }), mAToBCW._0), mACW._0)
          };
  };
  var applyRightWithAppendLog = function (appendLog, mABToCW, mABW) {
    return /* BiwriterT */{
            _0: Curry._2(Bimonad.apply_right, Curry._2(Bimonad.map_right, (function (param, param$1) {
                        return [
                                Curry._1(param[0], param$1[0]),
                                Curry._2(appendLog, param[1], param$1[1])
                              ];
                      }), mABToCW._0), mABW._0)
          };
  };
  var pureLeftWithLog = function (initial, a) {
    return /* BiwriterT */{
            _0: Curry._1(Bimonad.pure_left, [
                  a,
                  initial
                ])
          };
  };
  var pureRightWithLog = function (initial, b) {
    return /* BiwriterT */{
            _0: Curry._1(Bimonad.pure_right, [
                  b,
                  initial
                ])
          };
  };
  var bindLeftWithAppendLog = function (appendLog, aToWriterTCBW, mABW) {
    return /* BiwriterT */{
            _0: Curry._2(Bimonad.flat_map_left, (function (param) {
                    var w1 = param[1];
                    var mCDW = Curry._1(aToWriterTCBW, param[0]);
                    return Curry._3(Bimonad.bimap, (function (param) {
                                  return [
                                          param[0],
                                          Curry._2(appendLog, w1, param[1])
                                        ];
                                }), (function (param) {
                                  return [
                                          param[0],
                                          Curry._2(appendLog, w1, param[1])
                                        ];
                                }), mCDW._0);
                  }), mABW._0)
          };
  };
  var bindRightWithAppendLog = function (appendLog, bToWriterTACW, mABW) {
    return /* BiwriterT */{
            _0: Curry._2(Bimonad.flat_map_right, (function (param) {
                    var w1 = param[1];
                    var mCDW = Curry._1(bToWriterTACW, param[0]);
                    return Curry._3(Bimonad.bimap, (function (param) {
                                  return [
                                          param[0],
                                          Curry._2(appendLog, w1, param[1])
                                        ];
                                }), (function (param) {
                                  return [
                                          param[0],
                                          Curry._2(appendLog, w1, param[1])
                                        ];
                                }), mCDW._0);
                  }), mABW._0)
          };
  };
  var WithLog = function (Log) {
    var fromBimonad = function (bimonad) {
      return /* BiwriterT */{
              _0: Curry._3(Bimonad.bimap, (function (__x) {
                      return Relude_Tuple.make2(__x, Log.Monoid.empty);
                    }), (function (__x) {
                      return Relude_Tuple.make2(__x, Log.Monoid.empty);
                    }), bimonad)
            };
    };
    var Bifunctor = {
      bimap: bimap,
      map_left: mapLeft,
      map_right: mapRight
    };
    var apply_left = function (ff, fa) {
      return applyLeftWithAppendLog(Log.Monoid.append, ff, fa);
    };
    var apply_right = function (ff, fa) {
      return applyRightWithAppendLog(Log.Monoid.append, ff, fa);
    };
    var Biapply = {
      bimap: bimap,
      map_left: mapLeft,
      map_right: mapRight,
      apply_left: apply_left,
      apply_right: apply_right
    };
    var pure_left = function (a) {
      return pureLeftWithLog(Log.Monoid.empty, a);
    };
    var pure_right = function (b) {
      return pureRightWithLog(Log.Monoid.empty, b);
    };
    var Biapplicative = {
      bimap: bimap,
      map_left: mapLeft,
      map_right: mapRight,
      apply_left: apply_left,
      apply_right: apply_right,
      pure_left: pure_left,
      pure_right: pure_right
    };
    var flat_map_left = function (fa, f) {
      return bindLeftWithAppendLog(Log.Monoid.append, fa, f);
    };
    var flat_map_right = function (fb, f) {
      return bindRightWithAppendLog(Log.Monoid.append, fb, f);
    };
    var Bimonad$1 = {
      bimap: bimap,
      map_left: mapLeft,
      map_right: mapRight,
      apply_left: apply_left,
      apply_right: apply_right,
      pure_left: pure_left,
      pure_right: pure_right,
      flat_map_left: flat_map_left,
      flat_map_right: flat_map_right
    };
    return {
            make: make,
            fromBimonad: fromBimonad,
            runWriterT: runWriterT,
            execWriterT: execWriterT,
            tell: tell,
            listen: listen,
            listens: listens,
            pass: pass,
            censor: censor,
            Bifunctor: Bifunctor,
            bimapWriterT: bimapWriterT,
            bimap: bimap,
            bimapWithAppendLog: bimapWithAppendLog,
            mapLeft: mapLeft,
            mapLeftWithAppendLog: mapLeftWithAppendLog,
            mapRight: mapRight,
            mapRightWithAppendLog: mapRightWithAppendLog,
            map: mapLeft,
            mapWithAppendLog: mapLeftWithAppendLog,
            Biapply: Biapply,
            applyLeft: apply_left,
            applyLeftWithAppendLog: applyLeftWithAppendLog,
            applyRight: apply_right,
            applyRightWithAppendLog: applyRightWithAppendLog,
            apply: apply_left,
            applyWithAppendLog: applyLeftWithAppendLog,
            Biapplicative: Biapplicative,
            pureLeft: pure_left,
            pureRight: pure_right,
            pureRightWithLog: pureRightWithLog,
            pure: pure_left,
            pureLeftWithLog: pureLeftWithLog,
            Bimonad: Bimonad$1,
            flatMapLeft: flat_map_left,
            flatMapLeftWithAppendLog: bindLeftWithAppendLog,
            flatMapRight: flat_map_right,
            flatMapRightWithAppendLog: bindRightWithAppendLog,
            flatMap: flat_map_left,
            flatMapWithAppendLog: bindLeftWithAppendLog
          };
  };
  return {
          make: make,
          runWriterT: runWriterT,
          execWriterT: execWriterT,
          bimapWriterT: bimapWriterT,
          tell: tell,
          listen: listen,
          pass: pass,
          listens: listens,
          censor: censor,
          bimapWithAppendLog: bimapWithAppendLog,
          mapLeftWithAppendLog: mapLeftWithAppendLog,
          mapRightWithAppendLog: mapRightWithAppendLog,
          bimap: bimap,
          mapLeft: mapLeft,
          mapRight: mapRight,
          applyLeftWithAppendLog: applyLeftWithAppendLog,
          applyRightWithAppendLog: applyRightWithAppendLog,
          pureLeftWithLog: pureLeftWithLog,
          pureRightWithLog: pureRightWithLog,
          bindLeftWithAppendLog: bindLeftWithAppendLog,
          bindRightWithAppendLog: bindRightWithAppendLog,
          WithLog: WithLog
        };
}

function WithBimonadAndLog(Bimonad, Log) {
  var make = function (mWriter) {
    return /* BiwriterT */{
            _0: mWriter
          };
  };
  var runWriterT = function (mWriter) {
    return mWriter._0;
  };
  var execWriterT = function (writerT) {
    return Curry._3(Bimonad.bimap, (function (prim) {
                  return prim[1];
                }), (function (prim) {
                  return prim[1];
                }), writerT._0);
  };
  var bimapWriterT = function (mAWBWToMCWBW, mAWBW) {
    return /* BiwriterT */{
            _0: Curry._1(mAWBWToMCWBW, mAWBW._0)
          };
  };
  var tell = function (w) {
    return /* BiwriterT */{
            _0: Curry._1(Bimonad.pure_left, [
                  undefined,
                  w
                ])
          };
  };
  var listen = function (mAWBW) {
    return /* BiwriterT */{
            _0: Curry._3(Bimonad.bimap, (function (param) {
                    var w = param[1];
                    return [
                            [
                              param[0],
                              w
                            ],
                            w
                          ];
                  }), (function (param) {
                    var w = param[1];
                    return [
                            [
                              param[0],
                              w
                            ],
                            w
                          ];
                  }), mAWBW._0)
          };
  };
  var pass = function (m) {
    return /* BiwriterT */{
            _0: Curry._3(Bimonad.bimap, (function (param) {
                    var match = param[0];
                    return [
                            match[0],
                            Curry._1(match[1], param[1])
                          ];
                  }), (function (param) {
                    var match = param[0];
                    return [
                            match[0],
                            Curry._1(match[1], param[1])
                          ];
                  }), m._0)
          };
  };
  var listens = function (w1ToW2, writerTMABW1) {
    var m = listen(writerTMABW1);
    return /* BiwriterT */{
            _0: Curry._3(Bimonad.bimap, (function (param) {
                    var match = param[0];
                    var w1 = match[1];
                    return [
                            [
                              match[0],
                              Curry._1(w1ToW2, w1)
                            ],
                            w1
                          ];
                  }), (function (param) {
                    var match = param[0];
                    var w1 = match[1];
                    return [
                            [
                              match[0],
                              Curry._1(w1ToW2, w1)
                            ],
                            w1
                          ];
                  }), m._0)
          };
  };
  var censor = function (wToW, mABW) {
    return pass(/* BiwriterT */{
                _0: Curry._3(Bimonad.bimap, (function (param) {
                        return [
                                [
                                  param[0],
                                  wToW
                                ],
                                param[1]
                              ];
                      }), (function (param) {
                        return [
                                [
                                  param[0],
                                  wToW
                                ],
                                param[1]
                              ];
                      }), mABW._0)
              });
  };
  var bimapWithAppendLog = function (appendLog, aToC, bToD, mABW) {
    return /* BiwriterT */{
            _0: Curry._3(Bimonad.bimap, (function (param) {
                    return [
                            Curry._1(aToC, param[0]),
                            Curry._1(appendLog, param[1])
                          ];
                  }), (function (param) {
                    return [
                            Curry._1(bToD, param[0]),
                            Curry._1(appendLog, param[1])
                          ];
                  }), mABW._0)
          };
  };
  var mapLeftWithAppendLog = function (appendLog, aToB, writerT) {
    return bimapWithAppendLog(appendLog, aToB, Relude_Globals.id, writerT);
  };
  var mapRightWithAppendLog = function (appendLog, bToC, writerT) {
    return bimapWithAppendLog(appendLog, Relude_Globals.id, bToC, writerT);
  };
  var bimap = function (aToC, bToD, writerT) {
    return bimapWithAppendLog(Relude_Globals.id, aToC, bToD, writerT);
  };
  var mapLeft = function (aToB, writerT) {
    return bimap(aToB, Relude_Globals.id, writerT);
  };
  var mapRight = function (bToC, writerT) {
    return bimap(Relude_Globals.id, bToC, writerT);
  };
  var applyLeftWithAppendLog = function (appendLog, mAToBCW, mACW) {
    return /* BiwriterT */{
            _0: Curry._2(Bimonad.apply_left, Curry._2(Bimonad.map_left, (function (param, param$1) {
                        return [
                                Curry._1(param[0], param$1[0]),
                                Curry._2(appendLog, param[1], param$1[1])
                              ];
                      }), mAToBCW._0), mACW._0)
          };
  };
  var applyRightWithAppendLog = function (appendLog, mABToCW, mABW) {
    return /* BiwriterT */{
            _0: Curry._2(Bimonad.apply_right, Curry._2(Bimonad.map_right, (function (param, param$1) {
                        return [
                                Curry._1(param[0], param$1[0]),
                                Curry._2(appendLog, param[1], param$1[1])
                              ];
                      }), mABToCW._0), mABW._0)
          };
  };
  var pureLeftWithLog = function (initial, a) {
    return /* BiwriterT */{
            _0: Curry._1(Bimonad.pure_left, [
                  a,
                  initial
                ])
          };
  };
  var pureRightWithLog = function (initial, b) {
    return /* BiwriterT */{
            _0: Curry._1(Bimonad.pure_right, [
                  b,
                  initial
                ])
          };
  };
  var bindLeftWithAppendLog = function (appendLog, aToWriterTCBW, mABW) {
    return /* BiwriterT */{
            _0: Curry._2(Bimonad.flat_map_left, (function (param) {
                    var w1 = param[1];
                    var mCDW = Curry._1(aToWriterTCBW, param[0]);
                    return Curry._3(Bimonad.bimap, (function (param) {
                                  return [
                                          param[0],
                                          Curry._2(appendLog, w1, param[1])
                                        ];
                                }), (function (param) {
                                  return [
                                          param[0],
                                          Curry._2(appendLog, w1, param[1])
                                        ];
                                }), mCDW._0);
                  }), mABW._0)
          };
  };
  var bindRightWithAppendLog = function (appendLog, bToWriterTACW, mABW) {
    return /* BiwriterT */{
            _0: Curry._2(Bimonad.flat_map_right, (function (param) {
                    var w1 = param[1];
                    var mCDW = Curry._1(bToWriterTACW, param[0]);
                    return Curry._3(Bimonad.bimap, (function (param) {
                                  return [
                                          param[0],
                                          Curry._2(appendLog, w1, param[1])
                                        ];
                                }), (function (param) {
                                  return [
                                          param[0],
                                          Curry._2(appendLog, w1, param[1])
                                        ];
                                }), mCDW._0);
                  }), mABW._0)
          };
  };
  var WithLog = function (Log) {
    var fromBimonad = function (bimonad) {
      return /* BiwriterT */{
              _0: Curry._3(Bimonad.bimap, (function (__x) {
                      return Relude_Tuple.make2(__x, Log.Monoid.empty);
                    }), (function (__x) {
                      return Relude_Tuple.make2(__x, Log.Monoid.empty);
                    }), bimonad)
            };
    };
    var Bifunctor = {
      bimap: bimap,
      map_left: mapLeft,
      map_right: mapRight
    };
    var apply_left = function (ff, fa) {
      return applyLeftWithAppendLog(Log.Monoid.append, ff, fa);
    };
    var apply_right = function (ff, fa) {
      return applyRightWithAppendLog(Log.Monoid.append, ff, fa);
    };
    var Biapply = {
      bimap: bimap,
      map_left: mapLeft,
      map_right: mapRight,
      apply_left: apply_left,
      apply_right: apply_right
    };
    var pure_left = function (a) {
      return pureLeftWithLog(Log.Monoid.empty, a);
    };
    var pure_right = function (b) {
      return pureRightWithLog(Log.Monoid.empty, b);
    };
    var Biapplicative = {
      bimap: bimap,
      map_left: mapLeft,
      map_right: mapRight,
      apply_left: apply_left,
      apply_right: apply_right,
      pure_left: pure_left,
      pure_right: pure_right
    };
    var flat_map_left = function (fa, f) {
      return bindLeftWithAppendLog(Log.Monoid.append, fa, f);
    };
    var flat_map_right = function (fb, f) {
      return bindRightWithAppendLog(Log.Monoid.append, fb, f);
    };
    var Bimonad$1 = {
      bimap: bimap,
      map_left: mapLeft,
      map_right: mapRight,
      apply_left: apply_left,
      apply_right: apply_right,
      pure_left: pure_left,
      pure_right: pure_right,
      flat_map_left: flat_map_left,
      flat_map_right: flat_map_right
    };
    return {
            make: make,
            fromBimonad: fromBimonad,
            runWriterT: runWriterT,
            execWriterT: execWriterT,
            tell: tell,
            listen: listen,
            listens: listens,
            pass: pass,
            censor: censor,
            Bifunctor: Bifunctor,
            bimapWriterT: bimapWriterT,
            bimap: bimap,
            bimapWithAppendLog: bimapWithAppendLog,
            mapLeft: mapLeft,
            mapLeftWithAppendLog: mapLeftWithAppendLog,
            mapRight: mapRight,
            mapRightWithAppendLog: mapRightWithAppendLog,
            map: mapLeft,
            mapWithAppendLog: mapLeftWithAppendLog,
            Biapply: Biapply,
            applyLeft: apply_left,
            applyLeftWithAppendLog: applyLeftWithAppendLog,
            applyRight: apply_right,
            applyRightWithAppendLog: applyRightWithAppendLog,
            apply: apply_left,
            applyWithAppendLog: applyLeftWithAppendLog,
            Biapplicative: Biapplicative,
            pureLeft: pure_left,
            pureRight: pure_right,
            pureRightWithLog: pureRightWithLog,
            pure: pure_left,
            pureLeftWithLog: pureLeftWithLog,
            Bimonad: Bimonad$1,
            flatMapLeft: flat_map_left,
            flatMapLeftWithAppendLog: bindLeftWithAppendLog,
            flatMapRight: flat_map_right,
            flatMapRightWithAppendLog: bindRightWithAppendLog,
            flatMap: flat_map_left,
            flatMapWithAppendLog: bindLeftWithAppendLog
          };
  };
  var Biwriter = {
    make: make,
    runWriterT: runWriterT,
    execWriterT: execWriterT,
    bimapWriterT: bimapWriterT,
    tell: tell,
    listen: listen,
    pass: pass,
    listens: listens,
    censor: censor,
    bimapWithAppendLog: bimapWithAppendLog,
    mapLeftWithAppendLog: mapLeftWithAppendLog,
    mapRightWithAppendLog: mapRightWithAppendLog,
    bimap: bimap,
    mapLeft: mapLeft,
    mapRight: mapRight,
    applyLeftWithAppendLog: applyLeftWithAppendLog,
    applyRightWithAppendLog: applyRightWithAppendLog,
    pureLeftWithLog: pureLeftWithLog,
    pureRightWithLog: pureRightWithLog,
    bindLeftWithAppendLog: bindLeftWithAppendLog,
    bindRightWithAppendLog: bindRightWithAppendLog,
    WithLog: WithLog
  };
  var fromBimonad = function (bimonad) {
    return /* BiwriterT */{
            _0: Curry._3(Bimonad.bimap, (function (__x) {
                    return Relude_Tuple.make2(__x, Log.Monoid.empty);
                  }), (function (__x) {
                    return Relude_Tuple.make2(__x, Log.Monoid.empty);
                  }), bimonad)
          };
  };
  var Bifunctor = {
    bimap: bimap,
    map_left: mapLeft,
    map_right: mapRight
  };
  var apply_left = function (ff, fa) {
    return applyLeftWithAppendLog(Log.Monoid.append, ff, fa);
  };
  var apply_right = function (ff, fa) {
    return applyRightWithAppendLog(Log.Monoid.append, ff, fa);
  };
  var Biapply = {
    bimap: bimap,
    map_left: mapLeft,
    map_right: mapRight,
    apply_left: apply_left,
    apply_right: apply_right
  };
  var pure_left = function (a) {
    return pureLeftWithLog(Log.Monoid.empty, a);
  };
  var pure_right = function (b) {
    return pureRightWithLog(Log.Monoid.empty, b);
  };
  var Biapplicative = {
    bimap: bimap,
    map_left: mapLeft,
    map_right: mapRight,
    apply_left: apply_left,
    apply_right: apply_right,
    pure_left: pure_left,
    pure_right: pure_right
  };
  var flat_map_left = function (fa, f) {
    return bindLeftWithAppendLog(Log.Monoid.append, fa, f);
  };
  var flat_map_right = function (fb, f) {
    return bindRightWithAppendLog(Log.Monoid.append, fb, f);
  };
  var Bimonad$1 = {
    bimap: bimap,
    map_left: mapLeft,
    map_right: mapRight,
    apply_left: apply_left,
    apply_right: apply_right,
    pure_left: pure_left,
    pure_right: pure_right,
    flat_map_left: flat_map_left,
    flat_map_right: flat_map_right
  };
  return {
          Biwriter: Biwriter,
          Log: Log,
          make: make,
          fromBimonad: fromBimonad,
          runWriterT: runWriterT,
          execWriterT: execWriterT,
          tell: tell,
          listen: listen,
          listens: listens,
          pass: pass,
          censor: censor,
          Bifunctor: Bifunctor,
          bimapWriterT: bimapWriterT,
          bimap: bimap,
          bimapWithAppendLog: bimapWithAppendLog,
          mapLeft: mapLeft,
          mapLeftWithAppendLog: mapLeftWithAppendLog,
          mapRight: mapRight,
          mapRightWithAppendLog: mapRightWithAppendLog,
          map: mapLeft,
          mapWithAppendLog: mapLeftWithAppendLog,
          Biapply: Biapply,
          applyLeft: apply_left,
          applyLeftWithAppendLog: applyLeftWithAppendLog,
          applyRight: apply_right,
          applyRightWithAppendLog: applyRightWithAppendLog,
          apply: apply_left,
          applyWithAppendLog: applyLeftWithAppendLog,
          Biapplicative: Biapplicative,
          pureLeft: pure_left,
          pureRight: pure_right,
          pureRightWithLog: pureRightWithLog,
          pure: pure_left,
          pureLeftWithLog: pureLeftWithLog,
          Bimonad: Bimonad$1,
          flatMapLeft: flat_map_left,
          flatMapLeftWithAppendLog: bindLeftWithAppendLog,
          flatMapRight: flat_map_right,
          flatMapRightWithAppendLog: bindRightWithAppendLog,
          flatMap: flat_map_left,
          flatMapWithAppendLog: bindLeftWithAppendLog
        };
}

var BiwriterT = {
  WithBimonad: WithBimonad,
  WithBimonadAndLog: WithBimonadAndLog
};

exports.BiwriterT = BiwriterT;
/* Relude_Tuple Not a pure module */
